import { SearchIndex } from '../model/entry-tree/search-index';
import { EntityAdapter } from './interfaces/entity.adapter';

export class DefaultEntityAdapter<T> implements EntityAdapter<T> {
  constructor(
    protected readonly idField = 'id',
    protected readonly labelField = 'label',
    protected readonly iconField = 'icon',
  ) {}

  public getId(item: T): unknown {
    return item[this.idField];
  }

  public getLabel(item: T): string {
    return item[this.labelField] ?? '';
  }

  public getIcon(item: T): string | undefined {
    return item[this.iconField];
  }

  public getSearchIndex(item: T): SearchIndex {
    return { primary: this.getLabel(item) };
  }
}
